import React from 'react';
import { NavLink } from 'react-router-dom';
import { useJourney } from '../../context/JourneyContext';

const BottomNav = () => {
  const { isPregnant, isBabyMode } = useJourney();

  const tabs = isPregnant
    ? [
        { path:'/dashboard',       emoji:'🏠', label:'Home'      },
        { path:'/pregnancy',       emoji:'🤰', label:'Pregnancy' },
        { path:'/medical',         emoji:'🏥', label:'Medical'   },
        { path:'/profile',         emoji:'💕', label:'Profile'   },
        { path:'/ai',              emoji:'✨', label:'AI'        },
      ]
    : isBabyMode
    ? [
        { path:'/dashboard', emoji:'🏠', label:'Home'    },
        { path:'/baby',       emoji:'👶', label:'Baby'    },
        { path:'/medical',    emoji:'🏥', label:'Medical' },
        { path:'/profile',    emoji:'💕', label:'Profile' },
        { path:'/ai',         emoji:'✨', label:'AI'      },
      ]
    : [
        { path:'/dashboard',  emoji:'🏠', label:'Home'     },
        { path:'/period',     emoji:'🌸', label:'My Cycle' },
        { path:'/medical',    emoji:'🏥', label:'Medical'  },
        { path:'/profile',    emoji:'💕', label:'Profile'  },
        { path:'/ai',         emoji:'✨', label:'AI'       },
      ];

  return (
    <>
      <style>{`
        .ts-bnav-pill {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 3px;
          border-radius: 24px;
          transition: all 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
          padding: 6px 8px;
          min-width: 44px;
        }
        .ts-bnav-pill.active {
          background: linear-gradient(135deg, rgba(252,185,210,0.96) 0%, rgba(224,198,255,0.92) 100%);
          box-shadow: 0 4px 22px rgba(246,141,179,0.42), 0 2px 8px rgba(184,138,248,0.22), inset 0 1.5px 0 rgba(255,255,255,0.95);
          padding: 7px 16px;
          min-width: 56px;
        }
        .ts-bnav-emoji {
          font-size: 20px;
          line-height: 1;
          display: block;
          filter: none;
          opacity: 0.82;
          transition: all 0.24s ease;
        }
        .ts-bnav-pill.active .ts-bnav-emoji {
          font-size: 23px;
          filter: none;
          opacity: 1;
        }
        .ts-bnav-label {
          font-size: 9px;
          font-weight: 600;
          color: #8b6faa;
          letter-spacing: 0.02em;
          line-height: 1.2;
          white-space: nowrap;
          transition: all 0.24s ease;
          font-family: 'Nunito', 'Poppins', sans-serif;
        }
        .ts-bnav-pill.active .ts-bnav-label {
          font-size: 9px;
          font-weight: 800;
          color: #a02460;
        }
      `}</style>

      <nav
        className="fixed bottom-0 left-0 right-0 z-40 lg:hidden"
        style={{
          paddingBottom: 'env(safe-area-inset-bottom)',
          background: 'rgba(254,244,252,0.98)',
          backdropFilter: 'blur(28px) saturate(200%)',
          WebkitBackdropFilter: 'blur(28px) saturate(200%)',
          borderTop: '1.5px solid rgba(246,141,179,0.18)',
          boxShadow: '0 -4px 32px rgba(249,114,182,0.12), 0 -1px 0 rgba(255,255,255,0.60)',
        }}
      >
        <div style={{ display:'flex', height:68, alignItems:'center', padding:'0 4px' }}>
          {tabs.map(({ path, emoji, label }) => (
            <NavLink
              key={path}
              to={path}
              style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', height:'100%', textDecoration:'none' }}
            >
              {({ isActive }) => (
                <div className={`ts-bnav-pill${isActive ? ' active' : ''}`}>
                  <span className="ts-bnav-emoji">{emoji}</span>
                  <span className="ts-bnav-label">{label}</span>
                </div>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
